import {Component, Input, OnInit} from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
    selector: 'ngx-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss'],
})
export class ConfirmComponent implements OnInit {

    public headline = 'Eintrag löschen?';
    public headlineDeactivate = 'Eintrag deaktivieren?';
    public body = 'Möchten Sie diesen Eintrag löschen?';
    public bodyDeactivate = 'Möchten Sie diesen Eintrag deaktivieren?';
    @Input() deactivate: boolean = false;

    constructor(
        protected dialogRef: NbDialogRef<any>
    ) { }

    // tslint:disable-next-line:no-empty
    ngOnInit(): void { }

    public confirm(): void {
        this.dialogRef.close({delete: true});
    }

    public dismiss(): void {
        this.dialogRef.close();
    }

}
